import axios from "@/api/axiosInstance";
import { FetchMyVouchersCsvParams } from "./types";

export const fetchMyVouchersCsv = async (
  params: FetchMyVouchersCsvParams = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>("/api/private/my/vouchers/export", {
    responseType: "blob",
    params,
  });
  return response.data;
};
